var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overlay-segment",class:{ 'is-visible': _vm.isVisible, 'is-dialog': _vm.isDialog },on:{"click":_vm.onClick}})}
var staticRenderFns = []

export { render, staticRenderFns }